'use strict';

var Raven = require('raven-js');
var _ = require('lodash');

function RavenService (IdentityService, AuthService) {

  _.extend(this, {

    syncUser: function () {

      var userObj = IdentityService.getUser();
      if (AuthService.isAuthenticated() && userObj) {
        Raven.setUserContext({
          email: userObj.email,
          id: userObj.id
        });

        if (userObj.adminSession) {
          Raven.setExtraContext({
            adminSession: true
          });
        }
      }
      else {
        Raven.setUserContext({});
      }
    }

  });
}


RavenService.$inject = ['IdentityService', 'AuthService'];

module.exports = RavenService;


// WEBPACK FOOTER //
// ./src/common/raven/RavenService.js